import { render } from "./ObjectivesModal.vue?vue&type=template&id=f2e2bbea&scoped=true"
import script from "./ObjectivesModal.vue?vue&type=script&lang=js"
export * from "./ObjectivesModal.vue?vue&type=script&lang=js"

import "./ObjectivesModal.vue?vue&type=style&index=0&id=f2e2bbea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e2bbea"]])

export default __exports__